import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider, Container, Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./contexts/AuthContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import theme from "./theme";
import Navbar from "./components/Navbar";
import { Toaster } from "react-hot-toast";
import AppRoutes from "./AppRoutes";
import AdminCommentsPage from "./components/admin/AdminCommentsPage";
import PrivateRoute from "./components/PrivateRoute";
import UpdateWhatsApp from "./pages/UpdateWhatsApp";

// Get the base URL for the router
const getBasename = () => {
  if (process.env.NODE_ENV === "development") return "/";
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "5bc.us"
  )
    return "/";
  return process.env.REACT_APP_ROUTER_BASENAME || "/";
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <Router basename={getBasename()}>
            <Box sx={{ flexGrow: 1 }}>
              <Navbar />
              <Container>
                <Routes>
                  <Route path="/update-whatsapp" element={<UpdateWhatsApp />} />
                  <Route path="/*" element={<AppRoutes />} />
                  <Route
                    path="/admin/comments"
                    element={
                      <PrivateRoute adminOnly={true}>
                        <AdminCommentsPage />
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </Container>
              <Toaster position="top-right" />
            </Box>
          </Router>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
